import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { updateStockSelection } from "../../../../services/leaderBoard";
import moment from "moment";

export const UpcomingWeekTable = ({ data, refetch }) => {
  const emptyRow = [{
    player_name: "No players yet",
    rank: "-",
    days: [],
    user_id: null
  }];
  const playersToRender = data.players.length > 0 ? data.players : emptyRow;
  const [selectedStocks, setSelectedStocks] = useState({});
  const { seasonId } = useParams();

  const handleStockChange = async (
    dayKey,
    stockValue,
    day,
    player,
    stock_selection_id
  ) => {
    try {
      let res = await updateStockSelection(
        stock_selection_id,
        parseInt(seasonId),
        data.week,
        day.day,
        stockValue,
        player.user_id
      );
      refetch();
      console.log("response print === ", res);
      toast.success(res.message);
    } catch (error) {
      console.log("err === ", error);
      toast.error(error);
    }
  };

  const borderStyle = {
    borderLeft: "1px solid rgba(224, 224, 224, 1)",
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  };

  console.log("selectedStocks ==== ", data);
  return (
    <Box className="upcoming_week_table_cont">
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">
          Week {data.week} - {data.theme}
          <span className="upcoming_start_date">{moment(data.start_date).format("MM/DD/YYYY")}</span>
        </Typography>
      </Box>

      <TableContainer component={Paper} sx={{ maxWidth: "100%" }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Rank
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Player
              </TableCell>
              {/* Create a column for each day in the data */}
              {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                <TableCell key={day} sx={{ fontWeight: "bold" }}>
                  {day}
                </TableCell>
              ))}
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Total
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                Season Score
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {playersToRender.map((player) => (
              <TableRow key={player.player_name}>
                <TableCell sx={{ ...borderStyle }}>
                  <Typography variant="body2" fontWeight="bold">
                    {player.rank || "---"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ ...borderStyle }}>
                  <Typography variant="body2" fontWeight="bold">
                    {player.player_name}
                  </Typography>
                </TableCell>
                {player.days
                  ? // Regular row with data
                  player.days.map((day) => (
                    <TableCell
                      key={day.day}
                      sx={{
                        verticalAlign: "top",
                        ...borderStyle,
                        padding: "0px !important",
                      }}
                    >
                      <Typography
                        variant="body2"
                        fontWeight="bold"
                        sx={{
                          color: day?.daily_gain_loss?.startsWith("-")
                            ? "red"
                            : day.daily_gain_loss === "-"
                              ? "inherit"
                              : "green",
                        }}
                      >
                        {day.daily_gain_loss}
                      </Typography>
                      {day.stocks.length === 0
                        ? Array.from({ length: 3 }).map((_, index) => (
                          <Typography
                            key={index}
                            variant="caption"
                            component="div"
                          >
                            ----
                          </Typography>
                        ))
                        : day.stocks.map(
                          ({ stock, stock_selection_id }, stockIndex) => {
                            console.log("day stocks ==== ", stock);
                            return (
                              <div key={`${day.day}-${stockIndex}`} style={{ width: '100%' }}>
                                <FormControl
                                  variant="standard"
                                  size="small"
                                  fullWidth
                                >
                                  <Select
                                    labelId={`select-label-${day.day}-${stockIndex}`}
                                    id={`select-${day.day}-${stockIndex}`}
                                    sx={{
                                      padding: "0px 18px !important",
                                      color: "#212b36b2",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      "&:before": {
                                        borderBottom: "none",
                                      },
                                      width: "100%",
                                    }}
                                    value={
                                      selectedStocks[
                                      `${player.player_name}-${day.day}-${stockIndex}`
                                      ] || stock
                                    }
                                    onChange={(event) =>
                                      handleStockChange(
                                        `${player.player_name}-${day.day}-${stockIndex}`,
                                        event.target.value,
                                        day,
                                        player,
                                        stock_selection_id
                                      )
                                    }
                                  >
                                    {data.theme_stocks.map((value) => (
                                      <MenuItem key={value} value={value} sx={{
                                        color: "#212b36b2",
                                        fontSize: "12px",
                                        fontWeight: "400",
                                      }}>
                                        {value}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                            );
                          }
                        )}
                    </TableCell>
                  ))
                  : // Empty cells for days
                  ["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                    <TableCell sx={{ ...borderStyle }} key={day}>
                      -
                    </TableCell>
                  ))}
                <TableCell
                  sx={{
                    color: player?.weekly_gain_loss?.startsWith("-")
                      ? "red"
                      : player.weekly_gain_loss === "-"
                        ? "inherit"
                        : "green",
                    fontWeight: "bold",
                    ...borderStyle,
                  }}
                >
                  {player.weekly_gain_loss || "---"}
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", ...borderStyle }}>
                  {player?.season_score === null ? "---" : player?.season_score}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
